import qs from 'qs'

export interface QueryString {
  filter?: unknown
  populate?: unknown
  options?: unknown
  [x: string | number | symbol]: unknown
}

export const queryString = ({
  filter,
  populate,
  options,
  ...query
}: QueryString = {}) => {
  return qs.stringify(
    {
      ...query,
      filter: JSON.stringify(filter),
      populate: JSON.stringify(populate),
      options: JSON.stringify(options)
    },
    { encode: false }
  )
}
